/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetClientMonthlyReportSettings200Response
 */
export interface GetClientMonthlyReportSettings200Response {
    /**
     * Whether the report is mailed on the 1st of every month (report of the previous month).
     */
    enabled: boolean;
    /**
     * E-mail addresses the report is sent to, each as a separate mail. Required when enabled.
     */
    recipients: Array<string>;
}

/**
 * Check if a given object implements the GetClientMonthlyReportSettings200Response interface.
 */
export function instanceOfGetClientMonthlyReportSettings200Response(value: object): value is GetClientMonthlyReportSettings200Response {
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('recipients' in value) || value['recipients'] === undefined) return false;
    return true;
}

export function GetClientMonthlyReportSettings200ResponseFromJSON(json: any): GetClientMonthlyReportSettings200Response {
    return GetClientMonthlyReportSettings200ResponseFromJSONTyped(json, false);
}

export function GetClientMonthlyReportSettings200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetClientMonthlyReportSettings200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'enabled': json['enabled'],
        'recipients': json['recipients'],
    };
}

export function GetClientMonthlyReportSettings200ResponseToJSON(json: any): GetClientMonthlyReportSettings200Response {
    return GetClientMonthlyReportSettings200ResponseToJSONTyped(json, false);
}

export function GetClientMonthlyReportSettings200ResponseToJSONTyped(value?: GetClientMonthlyReportSettings200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enabled': value['enabled'],
        'recipients': value['recipients'],
    };
}

